import { useCallback } from "react";
import { useProfileStore } from "../stores/profileStore";
import { useAuth } from "./useAuth";

export function useProfile() {
  const { token } = useAuth();
  const { profile, isLoading, error, fetchProfile, updateProfile, uploadAvatar, deleteAvatar } =
    useProfileStore();

  const fetch = useCallback(async () => {
    if (!token) return;
    await fetchProfile(token);
  }, [token, fetchProfile]);

  const update = useCallback(
    async (data: { name?: string; bio?: string }) => {
      if (!token) return;
      return await updateProfile(token, data);
    },
    [token, updateProfile]
  );

  const upload = useCallback(
    async (file: File) => {
      if (!token) return;
      return await uploadAvatar(token, file);
    },
    [token, uploadAvatar]
  );

  const remove = useCallback(async () => {
    if (!token) return;
    await deleteAvatar(token);
  }, [token, deleteAvatar]);

  return {
    profile,
    isLoading,
    error,
    fetchProfile: fetch,
    updateProfile: update,
    uploadAvatar: upload,
    deleteAvatar: remove,
  };
}
